import { errorToast, successToast } from "./toastHelper";

 export const handleDownload = file => {
    if (!file) {
      errorToast("File not found");
    } else {
      const link = document.createElement("a");
      link.href = file;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.click();
      successToast("File downloaded successfully");
    }
  };